import script from "./VideoSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoSlide.vue?vue&type=script&setup=true&lang=js"

import "./VideoSlide.vue?vue&type=style&index=0&id=ca11fe0a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca11fe0a"]])

export default __exports__